import {Injectable} from '@angular/core';
import {BaseApiEndpointService} from '../base-endpoint/base-endpoint.service';
import {ServiceProviderHub} from '@generated-backend-types';
import Activity = ServiceProviderHub.App.Http.Resources.ServiceProviderHub.Events.Schedule.Activity;
import ActivityByEventPhase = ServiceProviderHub.App.Http.Resources.ServiceProviderHub.Events.Schedule.ActivityByEventPhase;
import {ListItem} from '../../types/list-item.type';
import Event = ServiceProviderHub.App.Http.Resources.ServiceProviderHub.Eventmanagement.Event.Event;

@Injectable()
export class EventActivityService extends BaseApiEndpointService<Activity, Activity, ActivityByEventPhase> {

  public forEvent(e: Event | string): void {
    const id = typeof e === 'string' ? e : e.id;
    this.endpoint = `/events/${id}/activities`;
  }

  public override modelToMultiSelectItem(m: Activity): ListItem & {model: Activity} {
    return {
      id: m.id,
      text: m.id,
      isDisabled: false,
      model: m,
    };
  }
}
